import { Box, ButtonGroup, Tooltip, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';

interface HistoryControlsProps {
  canUndo: boolean;
  canRedo: boolean;
  onUndo: () => void;
  onRedo: () => void;
  historySize?: number;
}

/**
 * History Controls Component
 *
 * Provides undo/redo buttons with keyboard shortcuts tooltips.
 * Optionally displays the number of states in history.
 */
export function HistoryControls({
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  historySize,
}: HistoryControlsProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <ButtonGroup size="small">
        <Tooltip title="Undo (Ctrl+Z)">
          <span>
            <Button
              onClick={onUndo}
              disabled={!canUndo}
              startIcon={<UndoIcon />}
            >
              Undo
            </Button>
          </span>
        </Tooltip>
        <Tooltip title="Redo (Ctrl+Y or Ctrl+Shift+Z)">
          <span>
            <Button
              onClick={onRedo}
              disabled={!canRedo}
              startIcon={<RedoIcon />}
            >
              Redo
            </Button>
          </span>
        </Tooltip>
      </ButtonGroup>
      {historySize !== undefined && historySize > 0 && (
        <Typography variant="caption" color="text.secondary">
          {historySize} {historySize === 1 ? 'state' : 'states'} in history
        </Typography>
      )}
    </Box>
  );
}
